<template>
  <div class="row list no-gutters shadow-sm pb-2 mb-3 bg-light">
    <div class="col px-3">
      <strong class="py-2 d-block">
        {{ serviceById(value.service_id).name[authLocale] }}
        <small v-if="numberOfCases[value.service_id] > 0">
          ({{ numberOfCases[value.service_id] }})
        </small>
      </strong>
      <div class="row">
        <div class="col">
          <a
            class="py-2 px-3 d-block pointer text-center bg-light border svg-sm"
            @click.prevent="fulfil(value.id)"
          >
            <span class="text-success">
              <YesIcon></YesIcon>
            </span>
            {{ $t("fulfiled") }}
          </a>
        </div>
        <div class="col">
          <a
            class="py-2 px-3 d-block pointer text-center bg-light border svg-sm"
            @click.prevent="fail(value.id)"
          >
            <span class="text-danger">
              <NoIcon></NoIcon>
            </span>
            {{ $t("failed") }}
          </a>
        </div>
        <div class="col">
          <a
            class="py-2 px-3 d-block pointer text-center bg-light border svg-sm"
            @click.prevent="cancel(value.id)"
          >
            <span class="text-primary">
              <RemoveIcon></RemoveIcon>
            </span>
            {{ $t("canceled") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import YesIcon from '@/components/Icons/Yes'
import NoIcon from '@/components/Icons/No'
import RemoveIcon from '@/components/Icons/Remove'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    YesIcon,
    NoIcon,
    RemoveIcon
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    caseId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      numberOfCases: {}
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      caseById: 'pcase/byId',
      serviceById: 'staticservice/byId',
      serviceRequests: 'pcase/serviceRequests'
    }),
    currentServiceRequests () {
      return this.serviceRequests(this.caseId)
    }
  },
  watch: {
    currentServiceRequests: {
      immediate: true,
      handler (services) {
        for (const s of services) {
          this.fetchCases(s.service_id)
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setServiceRequest: 'pcase/setServiceRequest'
    }),
    async add (service_id) {
      try {
        const params = {
          service_id: service_id
        }
        const response = await this.axios.post(
          `/api/patient-cases/${this.caseId}/service-requests`,
          params
        )
        this.setServiceRequest({
          id: this.caseId,
          serviceRequest: response.data.data
        })
      } catch (err) {
        this.setError(err)
      }
    },
    async fulfil (service_id) {
      try {
        const response = await this.axios.put(
          `/api/patient-cases/${this.caseId}/service-requests/${service_id}/fulfil`
        )
        this.setServiceRequest({
          id: this.caseId,
          serviceRequest: response.data.data
        })
      } catch (err) {
        this.setError(err)
      }
    },
    async cancel (service_id) {
      try {
        const response = await this.axios.put(
          `/api/patient-cases/${this.caseId}/service-requests/${service_id}/cancel`
        )
        this.setServiceRequest({
          id: this.caseId,
          serviceRequest: response.data.data
        })
      } catch (err) {
        this.setError(err)
      }
    },
    async fail (service_id) {
      try {
        const response = await this.axios.put(
          `/api/patient-cases/${this.caseId}/service-requests/${service_id}/fail`
        )
        this.setServiceRequest({
          id: this.caseId,
          serviceRequest: response.data.data
        })
      } catch (err) {
        this.setError(err)
      }
    },
    async fetchCases (service_id) {
      try {
        const params = {
          offset: 0,
          limit: 20,
          patient_id: this.caseById(this.caseId).patient_id,
          service_id: service_id,
          statuses: ['completed']
        }
        const response = await this.axios.get('/api/patient-cases', { params })
        this.$set(this.numberOfCases, service_id, response.data.data.length)
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
    "requestedServices": "მოთხოვნილი სერვისები (ლოდინის რეჟიმში)",
    "fulfiledServicesRequests": "შესრულებული მოთხოვნილი სერვისები",
    "failedServicesRequests": "შეუსრულებული მოთხოვნილი სერვისები",
    "canceledServicesRequests": "გაუქმებული მოთხოვნილი სერვისები",
    "fulfiled": "შესრულდა",
    "failed": "არ შესრულდა",
    "canceled": "გაუქმება"
  },
  "en": {
    "requestedServices": "Requested Services (Pending)",
    "fulfiledServicesRequests": "Fulfiled Requested Services",
    "failedServicesRequests": "Failed Requested Services",
    "canceledServicesRequests": "Cancelled Requested Services",
    "fulfiled": "Fulfiled",
    "failed": "Failed",
    "canceled": "Cancelled"
  }
}
</i18n>
